import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    section: {
      marginTop: 80,
      textAlign: "right",
    },
    root: {
      zIndex: theme.zIndex.faceModal,
    },
    paper: {
      position: "relative",
      width: 450,
      padding: [20, 24],
      textAlign: "center",
      overflowY: "initial",
      borderRadius: 10,
      boxShadow: "0 3px 6px 0 rgba(0,0,0,.25)",
      [theme.breakpoints.up("mobile")]: {
        width: 406,
        padding: [30, 40],
        borderRadius: 20,
      },
    },
    title: {
      color: theme.palette.cloudBirst,
      letterSpacing: ".5px",
      margin: "0 auto 10px",
      fontWeight: 500,
      fontSize: theme.typography.pxToRem(17),
      lineHeight: theme.typography.pxToRem(25),
      padding: 0,
      [theme.breakpoints.up("mobile")]: {
        fontSize: theme.typography.pxToRem(24),
        lineHeight: theme.typography.pxToRem(37),
        marginBottom: 20,
      },
    },
    description: {
      marginBottom: 15,
      textAlign: "left",
    },
    button: {
      width: "100%",
      marginBottom: 10,
    },
    deleteButton: {
      width: "100%",
      marginBottom: 10,
      backgroundColor: theme.palette.deletion.main,
      "&:hover": {
        backgroundColor: theme.palette.deletion.main,
      },
    },
    link: {
      "&:hover": {
        textDecoration: "underline",
      },
    },
  }),
  { name: "DeleteAccount" },
);
